(function($) {
	$('.indy-block-slider').each(function () {
		// on front page set slider max height
		const frontPageTitle = $('.front-page-header-title');
		if(frontPageTitle && window.innerWidth < 440) {
			const navbarHeight = $('.navbar').outerHeight(true);
			const frontPageTitleHeight = frontPageTitle.outerHeight(true);
			$(this).find($('.indy-block-slider-item'))
				.css('--to-subtract-height', `${navbarHeight + frontPageTitleHeight}px`)
				.addClass('subtract-height');
		}

		// init slider
		const slider = $(this).find($('.indy-block-slider-inner'));
		const sliderPrevArrow = $(this).find($('.indy-block-slider-previous-arrow'));
		const sliderNextArrow = $(this).find($('.indy-block-slider-next-arrow'));
		slider.slick({
			mobileFirst: true,
			infinite: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			prevArrow: sliderPrevArrow,
			nextArrow: sliderNextArrow,
			responsive: [
				{
					breakpoint: 576,
					settings: {
						infinite: false,
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 992,
					settings: {
						dots: true,
						slidesToShow: 3,
					},
				},
			],
		});
	});
})(jQuery);
